module.exports = __webpack_public_path__ + "img/tg_02 (11).4a127cac.jpg";